import axios from "axios";
import React, { useEffect, useState } from "react";
import NewsEntryList from "./NewsEntryList";
import classes from "./NewsEntryList.module.css";



function News() {
  const [news, setNews] = useState();


  
  useEffect(() => {
    const options = {
      method: 'GET', 
      url: 'https://api.newscatcherapi.com/v2/search',
      params: {q: 'Technology JavaScript Programming', lang: 'en', sort_by: 'relevancy', page: '1'},
      headers: {
        'x-api-key': 'DxjQWvGoSm4h8ZNIAXhIzuKDvhQxgrOcEtr3XZPJOGk'
      }
    }
    axios.request(options).then((response) => {
      console.log(response.data.articles);
      setNews(response.data.articles)
    })
  }, []);

  const newsEntryList = news?.map((article, index) => (
    <NewsEntryList key={index} {...article} />
  ));

  return (
    <div className={classes.newscontainer}>
      <div className={classes.sticky}>
      <label className={classes.topStories}>Tech Buzz</label>
      </div>
      <div className={classes.newsEntries}>
      {newsEntryList}
      </div>
    </div>
  );
}

export default News;
